// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"15":"7caeb12f486cca88","638":"7025a14d8ef4fbba","1516":"f63060b24da3dd6b","1804":"4f47ae4cbca404f7","3105":"b845bdaccd7a1c10","5642":"871faeffd79712fc","5835":"97cf485de54e05f7","5891":"00f8e78ae31e7272","6000":"d09d20ea7363115c"}[chunkId] + ".js";
};